<template>
  <new-modal-wrapper
    @before-open="setSizesInModal"
    :widthModal="'80%'"
    :maxWidthModal="500"
    ref="NewRepositionWarningModal"
    modal-name="NewRepositionWarningModal"
    :show-close-icon="false"
    :click-to-close="false"
    cta-primary-button="repositionReposition"
    @cta-action="startRepositionFlow"
  >
    <div>
      <div class="new-modal-error-icon">!</div>
      <h2 class="new-modal-title">{{ translations.repositionHeader }}</h2>
      <p class="new-modal-description">
        {{ translations.repositionSubHeader }}
        (<span>{{this.contentProps.prevUGCSize}}</span
        >)
        {{ translations.repositionSubHeader2 }}
        (<span>{{this.contentProps.newUGCSize}}</span
        >)
        {{ translations.repositionSubHeader3 }}
      </p>
    </div>
  </new-modal-wrapper>
</template>
<script>
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import repositionWarning from '@/mixins/UGC/repositionWarning';

export default {
  name: "NewRepositionWarningModal",
  components: {
    newModalWrapper
  },
  mixins: [repositionWarning],
};
</script>
